import s from './intro-4.css'

function animerHus(element, timeline) {
  // eslint-disable-next-line compat/compat
  const effect = new KeyframeEffect(element, { translate: ['0 0', '0 700px'] }, { fill: 'both' })

  // eslint-disable-next-line compat/compat
  const venstreAnimasjon = new Animation(effect, timeline)
  venstreAnimasjon.play()
}

function animerVenstre(element, timeline) {
  // eslint-disable-next-line compat/compat
  const effect = new KeyframeEffect(element, { translate: ['0 75px', '0 -75px'] }, { fill: 'both' })

  // eslint-disable-next-line compat/compat
  const venstreAnimasjon = new Animation(effect, timeline)
  venstreAnimasjon.play()
}

function animerHoyre(hoyreTre, timeline) {
  // eslint-disable-next-line compat/compat
  const effect = new KeyframeEffect(
    hoyreTre,
    { translate: ['0 120px', '0 -120px'] },
    { fill: 'both' },
  )

  // eslint-disable-next-line compat/compat
  const venstreAnimasjon = new Animation(effect, timeline)
  venstreAnimasjon.play()
}

export function initIntro4() {
  const textPart = document.querySelector('.intro-4 .dh-sa-part-text')
  if (!textPart) {
    return
  }

  const tekstbakgrunn = document.createElement('span')
  const textElement = textPart.querySelector('.dh-sa-large-text:nth-child(2)')
  tekstbakgrunn.append(...Array.from(textElement.childNodes))
  textElement.append(tekstbakgrunn)

  const lys = document.createElement('div')
  lys.classList.add(s.lys)

  const venstreTre = document.createElement('div')
  venstreTre.classList.add(s.treVenstre)

  const hoyreTre = document.createElement('div')
  hoyreTre.classList.add(s.treHoyre)

  textPart.appendChild(lys)
  textPart.appendChild(venstreTre)
  textPart.appendChild(hoyreTre)

  // Sett opp animasjoner

  // Opprett en tidslinje vi animerer dekklaget langs.
  // @ts-ignore
  const timeline = new ViewTimeline({ axis: 'block', subject: textPart })

  animerHus(lys, timeline)
  animerVenstre(venstreTre, timeline)
  animerHoyre(hoyreTre, timeline)
}
